import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import callApi from '../../utils/call_apis';
import bidSchema from '../../validations/Bid'
import Grid from '@mui/material/Grid';
import React from "react";
import Snackbar from '../generals/Snackbar';
import TextField from '@mui/material/TextField';
import { setSnackbar } from '../../stores/SnackbarSlice';
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import authUtil from '../../utils/auth_util';
import { useNavigate } from "react-router-dom";
import { setAuthUser } from '../../stores/AuthUserSlice';


function EmpLoginForm() {

  const initialValues = {
    'email': '',
    'password': '',
  }
  const [reqPayload, setReqPayload] = React.useState(initialValues);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmit = values => {
    // console.log('---onSubmit--values:', values);
    submitEmpLogin(values);
  }

  const formik = useFormik({
    initialValues,
    onSubmit,
    // validate,
    validationSchema: bidSchema.empLoginSchema,
    validateOnChange: false
  })

  // console.log('---formik--values:', formik.values);
  // console.log('---formik--errors:', formik.errors);

  const successResponse = (response) => {
    // console.log('---successResponse--response:', response);
    authUtil.setCredentials('auth-token', response.data.data.auth_token)
    authUtil.setCredentials('session-payload', JSON.stringify(response.data.data.session_payload))
    dispatch(setAuthUser(response.data.data.session_payload))
    dispatch(setSnackbar({
      status: 'success',
      message: response.data.message
    }))
    navigate('/emp/bid-listing')
  }

  const errorResponse = (error) => {
    formik.setErrors({ ...error.response.data.errors })
    // console.log('---errorResponse--formik--errors---221:', formik.errors);
    // dispatch(setSnackbar({
    //   status: 'error',
    //   message: error.response.data.message
    // }))
  }

  const submitEmpLogin = async (data, query = {}) => {
    try {
      // callApi.requestPOST(`${apiEndpoints.apiHost}/sellers-bids/emp/create-bid`, data, {}, successResponse, errorResponse)

      const response = await callApi.requestPOST(`/sellers-bids/emp/login`, data)
      // console.log('---submitEmpLogin---response:', response);
      successResponse(response)
      
    }
    catch (error) {
      // console.log('---submitEmpLogin---error:', error);
      errorResponse(error)
    }
  }


  return (
    <div>
      <Grid >

        <Box component="form" className="" onSubmit={formik.handleSubmit}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={10}>
              <TextField id="outlined-basic" className="tw-w-full" label="Email" type="email" name="email" variant="outlined" onChange={formik.handleChange} value={formik.values.email} error={formik.errors.email ? true : false} helperText={formik.errors.email} required />
            </Grid>

            <Grid item xs={12} sm={10}>
              <TextField id="outlined-basic" className="tw-w-full" xs={12} sm={6} label="Password" type="password" name="password" variant="outlined" onChange={formik.handleChange} value={formik.values.password} error={formik.errors.password ? true : false} helperText={formik.errors.password} required />
            </Grid>
            </Grid>

            <Grid container spacing={5}>
            <Grid item xs={12} sm={12} className="tw-mt-5">
              <Button type="submit" variant="contained">Login</Button>
            </Grid>
          </Grid>
        </Box>

      </Grid>

      <Snackbar />
    </div>
  );

}


export { EmpLoginForm };
